import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-file-upload",
  "use": "gw-file-upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-file-upload\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol